<template>
  <div>
    <div class="tile is-ancestor is-centered"> 
        <article class="tile is-child box">
         <h1 class="title">Edit Player</h1>
        <form v-on:submit="updatePlayer">
         <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Forename</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="text" placeholder="" v-model="Player.forename" required>
              </p>
            </div>
          </div>
         <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Surname</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="text" placeholder="" v-model="Player.surname" required>
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Number</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="number" min=1 max = 99 placeholder="" v-model="Player.number" required>
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Picture</label>
            </div>
            <div class="control is-grouped">
                <input class="input" type="file" id="file" ref="file" v-on:change="handleFileUpload()">
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">DOB</label>
            </div>
            <div class="control is-grouped">
                <datepicker  placeholder="--:--" :config="{ enableTime: false, enableSeconds: true, noCalendar: false, time_24hr:true }" v-model="Player.dob"></datepicker>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Birth Place</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="text" placeholder="" v-model="Player.birth_place" required>
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Nationality</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="text" placeholder="" v-model="Player.nationality" required>
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Position</label>
            </div>
            <div class="control is-grouped">
              <p class="control">
                <span class="select">
                  <select v-model="Player.position" required>
                    <option v-for="pos in positionOptions" v-bind:value="pos.value">
                      {{ pos.text }}
                    </option>
                  </select>
                </span>
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Height - Meters</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="number" placeholder="" v-model="Player.height"  step="0.01">
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Weight - lbs</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="number" placeholder="" v-model="Player.weight" step="0.01" >
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Handedness - L/R</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="text" placeholder="" v-model="Player.handedness" required>
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">External URL - Elite Prospects etc.</label>
            </div>
            <div class="control is-grouped">
              <p class="control is-expanded">
                <input class="input" type="text" placeholder="" v-model="Player.external_url">
              </p>
            </div>
          </div>
          <div class="control is-horizontal">
            <div class="control-label">
              <label class="label">Status</label>
            </div>
            <div class="control is-grouped">
              <p class="control">
                <span class="select">
                  <select v-model="Player.status" required>
                    <option v-for="status in statusOptions" v-bind:value="status.value" >
                      {{ status.text }}
                    </option>
                  </select>
                </span>
              </p>
            </div>
        </div>
          <div class="control">
            <button name="submit" class="button is-primary is-medium">Submit</button>
            <router-link class="button is-medium" v-bind:to="'/editors/player-editor/' + this.$route.params.teamId">Cancel</router-link>
          </div>
        </form>
        </article>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Cleave from 'vue-cleave'
import 'cleave.js/dist/addons/cleave-phone.cn'
import Datepicker from 'vue-bulma-datepicker'
import Notification from 'vue-bulma-notification'

const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  components: {
    Cleave,
    Datepicker,
    Notification
  },
  props: {
    player: Object
  },
  data () {
    return {
      file: '',
      positionOptions: [ {text: 'Left Wing - LW', value: 'LW'}, {text: 'Center - C', value: 'C'}, {text: 'Right Wing - RW', value: 'RW'}, {text: 'Left Defense - LD', value: 'LD'}, {text: 'Right Defense - RD', value: 'RD'}, {text: 'Goaltender - GT', value: 'GT'} ],
      statusOptions: [ {text: 'Active', value: 'Active'}, {text: 'Inactive', value: 'Inactive'}, {text: 'Retired', value: 'Retired'} ],
      Player: []
    }
  },

  methods: {
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    fetchPlayer () {
      this.$http.get('https://devilsapi.roblutken.com/api/players/get/' + this.$route.params.playerId, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        console.log(response.data)
        this.Player = response.data
        console.log(JSON.stringify(this.Player))
      }, response => {
      })
    },
    updatePlayer () {
      console.log(JSON.stringify(this.Player))
      /*eslint-disable */
      // eslint-disable-line no-use-before-define
      var formData = new FormData() // eslint-disable-line no-use-before-define
      formData.append('player_picture', this.file)
      formData.append('player',JSON.stringify(this.Player))
      /*eslint-enable */
      this.$http.post('https://devilsapi.roblutken.com/api/players/update/' + this.$route.params.teamId + '/' + this.Player.id, formData, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=', 'Content-Type': 'multipart/form-data' } }).then(
      response => {
        console.log(response.data)
        if (response.data.status === '202') {
          openNotification({
            title: 'Update Success',
            message: response.data.message,
            type: 'success',
            duration: 3400
          })
          this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
        } else {
          openNotification({
            title: 'Failed to update',
            message: response.data.message,
            type: 'danger',
            duration: 3400
          })
        }
      }, response => {
      })
    }
  },
  openNotificationWithType (type) {
    openNotification({
      title: 'This is a title',
      message: 'This is the message.',
      type: type
    })
  },
  watch: {
    'demo.value' (newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal)
    },
    'demo.rawValue' (newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal)
    }
  },
  created: function () {
    this.fetchPlayer()
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';
.tile.is-parent {
  margin-left:25%;
}
.button {
  margin: 5px 0 0;
}
.box:hover{
background-color: rgba(255, 255, 255, 1);
color: #ffffff;
cursor: normal;
}
.box:hover p{
color: #ffffff;
cursor: normal;
}
.control .button {
  margin: inherit;
}

.control.has-addons {
  @include mobile() {
    input {
      width: 100%;
    }

    input.is-expanded {
      flex-shrink: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// player-edit.vue?6dbb48b0